import { render, staticRenderFns } from "./deptBox.vue?vue&type=template&id=a5d489c0&scoped=true&"
import script from "./deptBox.vue?vue&type=script&lang=js&"
export * from "./deptBox.vue?vue&type=script&lang=js&"
import style0 from "./deptBox.vue?vue&type=style&index=0&id=a5d489c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d489c0",
  null
  
)

export default component.exports